export default __webpack_public_path__ + "static/media/QA_Icon.ec9b3bb3.svg";